import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { laptopAndBelow } from '@sorare/core/src/style/mediaQuery';

import { AnyPlayerFifteenStatsIcon } from 'components/player/AnyPlayerFifteenStatsIcon';
import { AnyPlayerStatsIcon } from 'components/player/AnyPlayerStatsIcon';

import type { AnyStatsIconCell_anyPlayer } from './__generated__/index.graphql';

const Wrapper = styled.div`
  width: var(--player-stats-icon-width);
  flex-shrink: 0;
  @media ${laptopAndBelow} {
    display: none;
  }
`;

type Props = {
  anyPlayer: AnyStatsIconCell_anyPlayer;
  onStatsClick: () => void;
};

export const AnyStatsIconCell = ({ anyPlayer, onStatsClick }: Props) => {
  const isLaptop = useIsLaptop();
  return (
    <Wrapper>
      {isLaptop ? (
        <AnyPlayerFifteenStatsIcon player={anyPlayer} onClick={onStatsClick} />
      ) : (
        <AnyPlayerStatsIcon player={anyPlayer} onClick={onStatsClick} />
      )}
    </Wrapper>
  );
};

AnyStatsIconCell.fragments = {
  anyPlayer: gql`
    fragment AnyStatsIconCell_anyPlayer on AnyPlayerInterface {
      slug
      ...AnyPlayerStatsIcon_anyPlayer
      ...AnyPlayerFifteenStatsIcon_anyPlayer
    }
    ${AnyPlayerFifteenStatsIcon.fragments.anyPlayer}
    ${AnyPlayerStatsIcon.fragments.anyPlayer}
  ` as TypedDocumentNode<AnyStatsIconCell_anyPlayer>,
};
